// extracted by mini-css-extract-plugin
export default {"container":"Fallback_container__Db3Ou"};